import { render, staticRenderFns } from "./Ledger.vue?vue&type=template&id=dc408c34&scoped=true"
import script from "./Ledger.vue?vue&type=script&lang=js"
export * from "./Ledger.vue?vue&type=script&lang=js"
import style0 from "./Ledger.vue?vue&type=style&index=0&id=dc408c34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc408c34",
  null
  
)

export default component.exports